import React from 'react'
import { useState } from 'react';
import CountUp from 'react-countup';
import SmokingRoomsIcon from '@mui/icons-material/SmokingRooms';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import FlightTakeoffOutlinedIcon from '@mui/icons-material/FlightTakeoffOutlined';
import DirectionsBoatOutlinedIcon from '@mui/icons-material/DirectionsBoatOutlined';
import ImportExportOutlinedIcon from '@mui/icons-material/ImportExportOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import '../App.css';
import {useTranslation } from "react-i18next";
import 'animate.css';


const About = () => {
  const { t } = useTranslation();
  
  const [counter,setCounter]=useState(false)

  return (
    <section className="homesec4" id="process">
    <div className='about'>
    <h3>  {t("about")} </h3>
   
    </div>
    <h4>  {t("aboutText")} </h4> 

      <div className="divLeft animate__animated animate__fadeInUp animate__delay-0.1s ">
        <ExploreOutlinedIcon className='ico'/>
        <div>
          <h1>{t("services")}</h1>
          <p>   
         
                  {t("servicesdec")}
                 </p>
        </div>
      </div>
      <div className="divRight animate__animated animate__fadeInUp animate__delay-0.5s ">
        <ImportExportOutlinedIcon className='ico'/>
        <div>
          <h1>   {t("import-export")}</h1>
          <h5> {t("import")} </h5>    <p>  {t("importdec")}</p>
          <h5>  {t("export")} </h5>    <p>  {t("exportdec")}</p>
      
        
    
        </div>
      </div>
      <div className="divLeft animate__animated animate__fadeInUp animate__delay-1.0s animate-duration: 2s">
        <FlightTakeoffOutlinedIcon className='ico'/>
        <div>
          <h5> {t("air")}</h5>
          
        </div>
      </div>
      <div className="divRight animate__animated animate__fadeInUp animate__delay-1.5s animate-duration: 2s">
      <DirectionsBoatOutlinedIcon className='ico'/>
        <div>
          <h5>{t("sea")} </h5>
         
        </div>
      </div>
      <div className="divLeft animate__animated animate__fadeInUp animate__delay-1.0s animate-duration: 2s">
      <LocalShippingOutlinedIcon className='ico'/>
        <div>
          <h5> {t("local")}</h5>

          <p> {t("localdec")}</p>
            
        </div>
      </div>
    
     
    </section>

  )
}

export default About